import { LiveAnnouncer } from '@angular/cdk/a11y';
import {
  Component,
  Input,
  OnChanges,
  SimpleChanges,
  inject,
} from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatChipEditedEvent, MatChipInputEvent } from '@angular/material/chips';
import { GridProgramService } from '@service';

@Component({
  selector: 'optima-programs-search',
  templateUrl: './programs-search.component.html',
  styleUrls: ['./programs-search.component.scss'],
})
export class ProgramsSearchComponent implements OnChanges {
  @Input() custom: boolean;
  search = new FormControl('');
  searchParams: string[] = [];
  announcer = inject(LiveAnnouncer);
  constructor(private gridProgramService: GridProgramService) {}

  ngOnChanges(change: SimpleChanges): void {
    if (change['custom']) {
      this.search.setValue('');
      this.searchParams = [];
    }
  }

  applyFilter(): void {
    this.gridProgramService.tableFilter(JSON.stringify(this.searchParams));
  }
  liveFilter(event: KeyboardEvent): void {
    this.gridProgramService.tableFilter(
      JSON.stringify([
        ...this.searchParams,
        (event.target as HTMLInputElement).value,
      ]),
    );
  }

  add(event: MatChipInputEvent): void {
    const value = (event.value || '').trim();

    if (value) {
      this.searchParams.push(value);
      this.applyFilter();
    }
    event.chipInput!.clear();
  }

  remove(param: string): void {
    const index = this.searchParams.indexOf(param);

    if (index >= 0) {
      this.searchParams.splice(index, 1);

      this.announcer.announce(`Removed ${param}`);
      this.applyFilter();
    }
  }

  edit(param: string, event: MatChipEditedEvent): void {
    const value = event.value.trim();
    if (!value) {
      this.remove(param);
      return;
    }
    const index = this.searchParams.indexOf(param);
    if (index >= 0) {
      this.searchParams[index] = value;
    }
    this.applyFilter();
  }
}
